import React from 'react'

import { LinearProgress } from '@mui/material'

import { quotaProgress, quotaSeverity } from 'components/_base/QuotaUsage'

type RevealUsageQuotaProps = {
  quota: number
  usage: number
}

const RevealUsageQuota = ({ quota, usage }: RevealUsageQuotaProps) => {
  return (
    <div className="reveal-usage-quota">
      <div className="reveal-usage-quota__label">{`${usage} / ${quota}`}</div>
      <LinearProgress
        color={quotaSeverity(quota, usage) ?? 'primary'}
        value={quotaProgress(quota, usage)}
        variant="determinate"
      />
    </div>
  )
}

export default RevealUsageQuota
